if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType;

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true },
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains(
                "page-overlay-cart-on",
              );
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cartType === "page") {
              if (this.error) this.disableLoadingInButton();
              return;
            }
            this.disableLoadingInButton();
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (this.error) return;
            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            this.quick_add_product =
              this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(
              ".wt__quick-buy-loader",
            );

            if (!this.quick_add_container.classList.contains("hidden")) {
              // use handle and quickbuy closeCart()

              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open",
              );
              this.quick_add_overlay.classList.remove(
                "wt__quick-buy--page-overlay--open",
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }
        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}


// 메인 할인 뱃지와 New뱃지 위치 조정
function updatePriceItemPosition() {
  // featured collection 페이지 뱃지
  document.querySelectorAll('.card__container').forEach(card => {
    const hasBadgeItem = card.querySelector('.card__badges .card__badges--item');
    const percentItem = card.querySelector('.price-item--percent');

    if (hasBadgeItem && percentItem) {
      if (window.innerWidth <= 899) {
        percentItem.style.top = '0px';
      } else {
        percentItem.style.top = '49px';
      }
    }
  });


  // main-product페이지 상단 뱃지
    document.querySelectorAll('.photoswipe').forEach(card => {
    const hasBadgeItem = card.querySelector('.card__badges .card__badges--item');
    const percentItem = card.querySelector('.detail-top-percent');

    if (hasBadgeItem && percentItem) {
      if (window.innerWidth <= 480) {
        percentItem.style.top = '48px';
      } 
      else if (window.innerWidth <= 899) {
        percentItem.style.top = '58px';
      } 
      else {
        percentItem.style.top = '75px';
      }
    }
  });

  
}

document.addEventListener('DOMContentLoaded', () => {
  updatePriceItemPosition(); // ✅ 처음 로드 시 적용
  window.addEventListener('resize', updatePriceItemPosition); // ✅ 창 크기 변경 시 적용
});


















// reelsup 뱃지 위치 조정
const moveAllBadges = () => {
  const cards = document.querySelectorAll('.reelUp_slide_visible,.reelUp_slide_wrapper');

  cards.forEach(card => {
    const badge = card.querySelector('.reelUp_save_badge_wrapper');
    const priceContainer = card.querySelector('.reelUp_slider_content .reelUp_slider_price_container');

    if (badge && priceContainer && !priceContainer.contains(badge)) {
      priceContainer.insertBefore(badge, priceContainer.firstChild);
      console.log('✅ 뱃지 이동 완료:', badge);
    }
  });
};

// DOM 변경 감지
const observer = new MutationObserver(() => {
  moveAllBadges();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


// main-product페이지 Goes well with 열고닫기
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js-upsell-toggle").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        const wrapper = trigger.parentElement.querySelector(".wt-product__upsell__content-wrapper");
        if (!wrapper) return;

        const isOpen = wrapper.classList.contains("is-open");
        if (isOpen) {
          wrapper.style.maxHeight = null;
          wrapper.classList.remove("is-open");
        } else {
          wrapper.style.maxHeight = wrapper.scrollHeight + "px";
          wrapper.classList.add("is-open");
        }

        // 버튼에도 on 클래스를 토글
        trigger.classList.toggle("on", !isOpen);
        // aria-expanded 속성도 업데이트
        trigger.setAttribute("aria-expanded", (!isOpen).toString());
      });
    });
  });








// 제품 Abib 2025 Magazine Box 상세에서만 이미지 배너 노출하기 
function moveBannerWhenReady() {
    const productNameEl = document.querySelector('.wt-product__name');
    const targetEl = document.querySelector('.wt-keys.features-banner-meta');
    const bannerEl = document.querySelector('.section-image-banner');

    if (productNameEl && targetEl && bannerEl) {
        const productName = productNameEl.textContent.trim();

        console.log("제품명:", productName);

        if (productName === 'Abib 2025 Magazine Box') {
            // targetEl을 부모에서 빼서 bannerEl 바로 다음(아래)에 넣기
            bannerEl.insertAdjacentElement('afterend', targetEl);

            bannerEl.style.maxWidth = '1600px';
            bannerEl.style.margin = '0 auto'; 
            bannerEl.style.display = 'block';
            targetEl.style.opacity = '1';
            console.log("배너 이동 완료!");
        } else {
            // 해당 제품이 아니면 그냥 targetEl 보이기
            targetEl.style.opacity = '1';
        }
    } else {
        // 요소가 없으면 100ms 후 다시 시도
        setTimeout(moveBannerWhenReady, 100);
    }
}

// 페이지 로드 시 실행
document.addEventListener('DOMContentLoaded', function() {
    moveBannerWhenReady();
});

